module.exports = __webpack_public_path__ + "img/max5.ab263bf9.jpg";